import React, { useState, useEffect } from "react";
import Text from "../../../../../../../_components/Text";
import LoadingInput from "../../../../../../../_components/LoadingInput";

import { CreateNFeContext } from "../../../Context";

function getCurrentDateTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export default (props) => {
  const context = React.useContext(CreateNFeContext);
  const isSendDate = props.dateType === "sendDate";
  const fieldKey = isSendDate ? "send_date" : "update_date";

  const contextDate =
    context &&
    context.nfe &&
    context.nfe.identification &&
    context.nfe.identification[fieldKey];
  const [dateTime, setDateTime] = useState(contextDate || getCurrentDateTime());

  // Sincroniza se o contexto for atualizado (ex: ao carregar rascunho ou resetar)
  useEffect(() => {
    if (contextDate) {
      setDateTime(contextDate);
    } else {
      const now = getCurrentDateTime();
      setDateTime(now);
      if (context && context.nfe && context.nfe.identification) {
        context.nfe.identification[fieldKey] = now;
        if (context.handlers && context.handlers.updateNFeData) {
          context.handlers.updateNFeData(context.nfe);
        }
      }
    }
  }, [contextDate, fieldKey]);

  function onChangeDate(e) {
    const value = e.target.value;
    if (!value) return;
    setDateTime(value);
    const nfe = context && context.nfe;
    if (nfe && nfe.identification) {
      nfe.identification[fieldKey] = value;
      if (context && context.handlers && context.handlers.updateNFeData) {
        context.handlers.updateNFeData(nfe);
      }
    }
  }

  // Atualiza automaticamente a cada minuto se a data ainda for o momento corrente
  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = getCurrentDateTime();
      const currentVal =
        context &&
        context.nfe &&
        context.nfe.identification &&
        context.nfe.identification[fieldKey];
      if (!currentVal || currentVal === dateTime) {
        setDateTime(now);
        if (context && context.nfe && context.nfe.identification) {
          context.nfe.identification[fieldKey] = now;
          if (context.handlers && context.handlers.updateNFeData) {
            context.handlers.updateNFeData(context.nfe);
          }
        }
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [dateTime, fieldKey]);

  return isSendDate ? (
    <div>
      <Text color="primary">Data de emissão da NF-e</Text>
      <LoadingInput required onChange={onChangeDate} value={dateTime} type="datetime-local" />
    </div>
  ) : (
    <div>
      <Text color="primary">Data de saída da NF-e</Text>
      <LoadingInput required onChange={onChangeDate} value={dateTime} type="datetime-local" />
    </div>
  );
};




// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/SendDate/index.jsx